import React from 'react';
import { SvgIcon } from '@material-ui/core';

var DownArrowIcon = function DownArrowIcon(props) {
  return React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, props), React.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }));
};

export default DownArrowIcon;